import userOrderService from 'lib/services/userOrderService';
import { showReceiveLimitDialog, showReceiveLoadingDialog } from '.';
import channelService from 'lib/services/channelService';
import storage from 'lib/utils/storage';
import { showModal } from '../Modal';

export const CMCC_RECEIVE_DATA = 'CMCC_RECEIVE_DATA';

export const generatorStorageKey = () => {
  const token = localStorage.getItem('nickName') || channelService.gameCode;
  const userOrderInfo = userOrderService.getUserOrderInfo();
  return `${CMCC_RECEIVE_DATA}_${token}_${userOrderInfo.orderMobile}`;
};

export const handleCMCCPrizeReceive = (mobile, gameId, props) => {
  const isOpenReceiveTips = storage.getStorage(generatorStorageKey());
  // 判断未打开过发起领取弹窗
  if (!isOpenReceiveTips && props?.isOverYear) {
    // modal show
    showModal(showReceiveLimitDialog(false, gameId, props));
    return;
  }
  showModal(showReceiveLoadingDialog(mobile, gameId, props));
  // show tips
};
